import { Category } from "../../category/category";

export class responseUpdateCategory {
    category: Category;
    dealerGroupId: number;
    name: string;
    ordinal: number;
    productCategoryId: number;
    productId: number;
    constructor(data) {
        this.category =  data.category;
        this.dealerGroupId =  data.dealerGroupId;
        this.name = data.name;
        this.ordinal = data.ordinal;
        this.productCategoryId = data.productCategoryId;
        this.productId = data.productId;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/http/res/response-update-category.ts